import picturePreview from './picturePreview';
export default picturePreview;



// WEBPACK FOOTER //
// ./src/components/picturePreview/index.js